import { FC, useEffect } from 'react';
import { useBundleUpdate } from 'hooks/use-bundle-update.hook';

const RELOAD_DELAY_MS = 5_000;

/**
 * Silently checks for new app builds once per day after 8 PM.
 * When a new version is detected, reloads the page after a short delay.
 */
export const BundleUpdateManager: FC = () => {
  const { updateAvailable, applyUpdate } = useBundleUpdate();

  useEffect(() => {
    if (!updateAvailable) return undefined;

    const timer = setTimeout(() => {
      applyUpdate();
    }, RELOAD_DELAY_MS);

    return () => clearTimeout(timer);
  }, [updateAvailable, applyUpdate]);

  return null;
};
